import React from 'react';
import { CheckCircle2Icon, ClockIcon, FileTextIcon, RotateCwIcon } from 'lucide-react';
import type { ESignPackage } from '../../types/docmagic';
import type { BusyAction } from '../../hooks/usePackages';
import { allRequiredComplete } from '../../utils/packageStatus';
interface SignedPdfCardProps {
  pkg: ESignPackage;
  busy?: BusyAction;
  onRetry: () => void;
}
export function SignedPdfCard({
  pkg,
  busy,
  onRetry
}: SignedPdfCardProps) {
  const ready = allRequiredComplete(pkg);
  return <section aria-labelledby="pdf-heading" className="rounded border border-line p-4" data-id="element-50" data-mp="9n28j47a3ktv">
      <h3 id="pdf-heading" className="text-sm font-bold text-ink" data-id="element-51" data-mp="emf6ajzoucb8">Signed Package</h3>

      {pkg.pdfStatus === 'Stored' && pkg.pdfFileName ? <div className="mt-3" data-id="element-52" data-mp="jnmdohxx59hd">
          <div className="flex items-start gap-2 rounded bg-[#ebf7e6] p-3" data-id="element-53" data-mp="jjovbyj60lyj">
            <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" data-id="element-54" data-mp="1q1u41pzq187e" />
            <p className="text-sm text-ink" data-id="element-55" data-mp="1uzdiapwf5kzc">Attached to the loan record. DocMagic received 201 Created.</p>
          </div>
          <a href="#" onClick={e => e.preventDefault()} className="mt-3 flex items-center gap-2 text-sm text-brand hover:underline" data-id="element-56" data-mp="tfv1xbr8phkt">
            <FileTextIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-57" data-mp="pdhtgfl3z5kc" />
            <span className="break-all" data-id="element-58" data-mp="kfgcc078tgbi">{pkg.pdfFileName}</span>
          </a>
        </div> : ready ? <div className="mt-3" data-id="element-59" data-mp="fgn1kfjcc3f1">
          <p className="text-sm text-ink" data-id="element-60" data-mp="fgva5v8fkmkf">All required borrowers have signed. The signed PDF has not been stored yet.</p>
          <button type="button" onClick={onRetry} disabled={busy === 'pdf'} className="mt-3 inline-flex items-center gap-1.5 rounded bg-brand px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-dark disabled:cursor-wait disabled:opacity-70" data-id="element-61" data-mp="anabs22xdqkp">
            <RotateCwIcon className={`h-4 w-4 ${busy === 'pdf' ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-62" data-mp="3swudncy36wd8" />
            {busy === 'pdf' ? 'Retrieving…' : 'Retry retrieval'}
          </button>
        </div> : <div className="mt-3 flex items-start gap-2 text-sm text-muted" data-id="element-63" data-mp="3j7dx3dwt4r95">
          <ClockIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-64" data-mp="3j5ayw6li3rtc" />
          <p data-id="element-65" data-mp="34bo95a82a41s">Waiting on borrower signatures. The signed PDF is retrieved and attached automatically on completion.</p>
        </div>}
    </section>;
}